import React from 'react';

const ParticipantesSection: React.FC<{participantes: Array<{imagem: string}>}> = ({participantes}) => {
    return (
        <section className='py-8 max-w-[1920px] mx-auto'>
            <h3 className="text-2xl font-semibold text-center text-balance">
                Instituições Participantes
            </h3>

            <div className="flex justify-center flex-wrap gap-6 mt-8">
                {participantes.map((item, index) => (
                    <img key={index} src={item.imagem} alt="Imagem do apoiador" className="w-1/2 sm:w-1/3 md:w-[calc(100%/5)] lg:w-[calc(100%/7)] h-auto py-2 px-4" />
                ))}
            </div>
        </section>
    );
};

export default ParticipantesSection;